import React, { useCallback, useEffect, useRef, useState } from 'react'

import GridCard from '../GridCard'

import 'styles/BlogSlider.scss'

const BlogSlider = ({ title, posts }) => {
  const viewportRef = useRef(null)
  const [canScrollPrev, setCanScrollPrev] = useState(false)
  const [canScrollNext, setCanScrollNext] = useState(false)

  const updateNav = useCallback(() => {
    const el = viewportRef.current
    if (!el) return
    setCanScrollPrev(el.scrollLeft > 0)
    setCanScrollNext(el.scrollLeft < el.scrollWidth - el.clientWidth - 1)
  }, [])

  useEffect(() => {
    const el = viewportRef.current
    if (!el) return undefined
    updateNav()
    el.addEventListener('scroll', updateNav)
    window.addEventListener('resize', updateNav)
    return () => {
      el.removeEventListener('scroll', updateNav)
      window.removeEventListener('resize', updateNav)
    }
  }, [posts, updateNav])

  const scroll = (direction) => {
    const el = viewportRef.current
    if (!el) return
    const slides = Array.from(el.querySelectorAll('.blog-slider__slide'))
    if (!slides.length) return

    const { scrollLeft } = el
    const currentIndex = slides.findIndex(
      (slide, index) =>
        slide.offsetLeft + slide.offsetWidth / 2 > scrollLeft + 1 ||
        index === slides.length - 1
    )
    const nextIndex = Math.min(
      Math.max(currentIndex + direction, 0),
      slides.length - 1
    )

    el.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' })
  }

  if (!posts.length) return null

  return (
    <div className="blog-slider">
      <div className="blog-slider__header">
        <h2 className="with-dot mb-0 blog-slider__title">{title}</h2>
        {posts.length > 1 && (
          <div className="blog-slider__nav">
            <button
              type="button"
              className="blog-slider__btn blog-slider__btn--prev"
              aria-label="Vorige"
              disabled={!canScrollPrev}
              onClick={() => scroll(-1)}
            />
            <button
              type="button"
              className="blog-slider__btn blog-slider__btn--next"
              aria-label="Volgende"
              disabled={!canScrollNext}
              onClick={() => scroll(1)}
            />
          </div>
        )}
      </div>
      <div className="blog-slider__viewport" ref={viewportRef}>
        <div className="blog-slider__track">
          {posts.map((node, key) => (
            <GridCard
              key={node.path || key}
              asSlide
              path={node.path}
              image={node.acf.banner}
              title={node.title}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default BlogSlider
